import { axios } from '@/services/axios';

/**
 * Updates a service category. Mirrors createServiceCategory's single
 * combined multipart payload — the backend accepts image + fields together
 * in one request for both create and update.
 *
 * @param {object} serviceCategoryData
 * @param {string} serviceCategoryData.id
 * @param {string} serviceCategoryData.name
 * @param {string} [serviceCategoryData.description]
 * @param {File|string} [serviceCategoryData.image] New file, or the existing image filename when unchanged.
 * @param {string} serviceCategoryData.type
 */
export const updateServiceCategory = ({
    id,
    name,
    description,
    image,
    type,
}) => {
    const formData = new FormData();
    formData.append('id', id);
    formData.append('name', name);
    formData.append('description', description || '');
    formData.append('image', image);
    formData.append('type', type);

    return axios.put('/servicecategory', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
